/**
 * 公众号品牌设置接口地址：http://gitlab.10niu.cn/organization/repository/editor?id=21&mod=540&itf=3583
 */

import config from '@/config';
import request from '@/request/request.gateway.js';
import qs from 'qs';

export default {
	// 获取公众号列表
	getOfficialAccountList(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/brand-config/get_wechat_official_account_list`,
			params
		});
	},
	// 获取公众号配置信息
	getBrandConfig(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/brand-config/get_brand_config`,
			params
		});
	},
	// 编辑公众号配置信息
	postEditBrandConfig(data) {
		return request({
			method: 'post',
			url: `${config.api.admin}/brand-config/edit_brand_config`,
			data: qs.stringify(data)
		});
	}
};
